<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Inventory On Hand by Group"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'financeReport', label: 'Finance' },
            {
              name: 'inventoryOnHandGroupAsOf',
              label: 'Inventory On Hand by Group',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          :filterByTimeAsOf="true"
          @submit-filter="performGetReport"
          :isLoading="inventoryTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr><td colspan="3">Inventory On Hand</td></tr>
                <tr><td colspan="3">{{ reportData.total.datePeriod }}</td></tr>
                <tr><td> </td></tr><tr><td> </td></tr>
                <tr>
                  <th align="left">Name</th>
                  <th align="right">Quantity</th>
                  <th align="right">Dollar Value</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                  <td>{{ record.group }}</td>
                  <td align="right"> {{ record.quantity }}</td>
                  <td align="right"> {{ Utilities.formatPrice(record.dollarValue) }}</td>
                </tr>
              </tbody>
              <tr class="skip-export">
                <td colspan="100%">
                  <hr class="line1" />
                </td>
              </tr>
              <tr>
                <td> Totals </td>
                <td align="right">
                  {{ reportData.total.quantity }}
                </td>
                <td align="right"> {{ Utilities.formatPrice(reportData.total.dollarValue) }}</td>
              </tr>
              <tr class="skip-export"></tr>
              <tr class="skip-export">
                <td colspan="100%"><hr class="line1" /></td>
              </tr>

            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Inventory On Hand by Group");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        financeTransactions: "reports/financeTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getSalesTransactions: "reports/getFinanceTransactions",
      }),
      performGetReport(filter) {
        let reportType = "inventoryOnHandGroupAsOf";
        this.getSalesTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "inventoryOnHandGroup");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_inventoryOnHandGroupAsOf.scss";